export default [
  {
    path: '/main/arena/clean-positions',
    meta: {
      tag: 'list_arena_clean_position',
      name: 'Limpar Posicionamentos',
      breadcrumb: 'Limpar Posicionamentos'
    },
    component: () => import(/* webpackChunkName: "arena-clean-position-list" */ '@/views/main/settings/arena/clean-position/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenacleanposition',
        meta: {
          tag: 'list_arena_clean_position',
          menu: 'settings',
          name: 'Limpar Posicionamentos'
        },
        component: () => import(/* webpackChunkName: "arena-clean-position-list" */ '@/views/main/settings/arena/clean-position/List.vue'),
      }
    ]
  }
]
